import { render } from "./ModalWrapper.vue?vue&type=template&id=d1ee1b5e&ts=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__